import { tabelaAtual } from './combateTabela';

/** Ids com ficha em `ConsumableUse` no servidor. Só estes entram na barra. */
export const CONSUMIVEIS = [
  'bandage',
  'healing',
  'greater-healing',
  'cure-poison',
  'mana',
  // techspec-pocoes: recuperação
  'greater-mana',
  'greater-cure',
  'refresh',
  'total-refresh',
  // techspec-pocoes: efeito temporário
  'strength-potion',
  'greater-strength',
  'agility-potion',
  'greater-agility',
  'nightsight',
  'magic-resist'
] as const;

export type ConsumivelId = (typeof CONSUMIVEIS)[number];
export type ConsumivelEspecie = 'vida' | 'antidoto' | 'mana' | 'vigor' | 'buff';

export const ESPECIE: Record<ConsumivelId, ConsumivelEspecie> = {
  bandage: 'vida',
  healing: 'vida',
  'greater-healing': 'vida',
  'cure-poison': 'antidoto',
  mana: 'mana',
  'greater-mana': 'mana',
  'greater-cure': 'antidoto',
  refresh: 'vigor',
  'total-refresh': 'vigor',
  'strength-potion': 'buff',
  'greater-strength': 'buff',
  'agility-potion': 'buff',
  'greater-agility': 'buff',
  nightsight: 'buff',
  'magic-resist': 'buff'
};

const IDS = new Set<string>(CONSUMIVEIS);
const GRATIS = new Set<string>(['healing', 'mana']);
/** Toda poção com pilha: o VIP usa sem ter na mochila, pagando prata (techspec-pocoes). */
const VIP = new Set<string>(CONSUMIVEIS.filter(id => id !== 'bandage' && !GRATIS.has(id)));

export function ehConsumivel(id: string | null | undefined): id is ConsumivelId {
  return !!id && IDS.has(id);
}

/** Poção de vida e poção de mana: só existem na barra, sem pilha. */
export function ehGratis(id: string | null | undefined): boolean {
  return !!id && GRATIS.has(id);
}

/** Toda poção com pilha: a pilha acaba e o VIP passa a debitar a prata (mochila e banco). */
export function ehPocaoVip(id: string | null | undefined): boolean {
  return !!id && VIP.has(id);
}

export const ITENS_CURA = CONSUMIVEIS.filter(id => ESPECIE[id] === 'vida');

/** Vida e antídoto dividem a espera. Mana, vigor e as de efeito têm a própria. Bandagem é outra. */
export type GrupoConsumivel = 'bandagem' | 'pocao' | 'pocao-mana' | 'pocao-vigor' | 'pocao-buff';

/** `null` se não for consumível — magia e arma não entram no CD das poções. */
export function grupoConsumivel(id: string | null | undefined): GrupoConsumivel | null {
  if (!ehConsumivel(id)) return null;
  if (id === 'bandage') return 'bandagem';
  switch (ESPECIE[id]) {
    case 'mana': return 'pocao-mana';
    case 'vigor': return 'pocao-vigor';
    case 'buff': return 'pocao-buff';
    default: return 'pocao';
  }
}

/** Bandagem: ~15 s. Poções: da tabela (padrão 10 s), compartilhado. */
export function esperaConsumivelMs(id: string): number {
  if (id === 'bandage') return 15_100;
  return Math.max(100, Math.round(tabelaAtual().pocaoEsperaS * 1000));
}
